module.exports = __webpack_public_path__ + "static/media/birthdaysIcons.e97c5b4f.svg";